import { addDoc, collection, serverTimestamp } from 'firebase/firestore';

import { getFirestoreDb } from '../config/firebaseApp';
import type { ReportReasonKey, ReportTargetType } from '../types/reports';

const COL = 'reports';

export const REPORT_REASON_OPTIONS: { key: ReportReasonKey; label: string }[] = [
  { key: 'inappropriate', label: 'Uygunsuz içerik' },
  { key: 'harassment', label: 'Taciz / nefret söylemi' },
  { key: 'fraud', label: 'Yanıltıcı / dolandırıcılık' },
  { key: 'spam', label: 'Spam' },
  { key: 'copyright', label: 'Telif veya kişisel veri' },
  { key: 'other', label: 'Diğer' },
];

export type SubmitReportInput = {
  reporterId: string;
  targetType: ReportTargetType;
  targetAuthorId: string;
  reasonKey: ReportReasonKey;
  description: string;
  forumPostId?: string;
  forumCommentId?: string;
  marketplaceListingId?: string;
};

export async function submitReport(input: SubmitReportInput): Promise<void> {
  const desc = input.description.trim();
  if (desc.length < 1 || desc.length > 2000) {
    throw new Error('Açıklama 1–2000 karakter olmalı.');
  }
  const base = {
    reporterId: input.reporterId,
    targetType: input.targetType,
    targetAuthorId: input.targetAuthorId,
    reasonKey: input.reasonKey,
    description: desc,
    createdAt: serverTimestamp(),
  };
  if (input.targetType === 'forum_post') {
    if (!input.forumPostId) {
      throw new Error('forumPostId gerekli.');
    }
    await addDoc(collection(getFirestoreDb(), COL), {
      ...base,
      forumPostId: input.forumPostId,
    });
    return;
  }
  if (input.targetType === 'forum_comment') {
    if (!input.forumPostId || !input.forumCommentId) {
      throw new Error('forumPostId ve forumCommentId gerekli.');
    }
    await addDoc(collection(getFirestoreDb(), COL), {
      ...base,
      forumPostId: input.forumPostId,
      forumCommentId: input.forumCommentId,
    });
    return;
  }
  if (input.targetType === 'marketplace_listing') {
    if (!input.marketplaceListingId) {
      throw new Error('marketplaceListingId gerekli.');
    }
    await addDoc(collection(getFirestoreDb(), COL), {
      ...base,
      marketplaceListingId: input.marketplaceListingId,
    });
    return;
  }
  throw new Error('Geçersiz hedef türü.');
}
